import { call, put } from 'redux-saga/effects';
import { signalingWhiteboardOpened } from 'features/layout/features/content/actions';
import { previewFileOpened } from 'features/content-library/contentLibrarySlice';
import { formatToWhiteboardFile } from 'features/content-library/utils/format';
import { loaderDisplayChanged } from 'features/whiteboard/whiteboardSlice';
import { initWhiteboardSaga } from 'features/whiteboard/sagas/initWhiteboardSaga';

export function* previewWhiteboardSaga(action: ReturnType<typeof signalingWhiteboardOpened>) {
  const { data, initiator } = action.payload;

  yield put(loaderDisplayChanged(true));
  yield call(initWhiteboardSaga, data, initiator, { readOnly: true });
  yield put(previewFileOpened(formatToWhiteboardFile(data)));
  yield put(loaderDisplayChanged(false));
}
